// src/pages/Account/SubscriptionManagement.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

const SubscriptionManagement = ({ userData, onCancel }) => {
    const { t } = useTranslation();
    const isActive = userData.subscription_status === 'active';

    return (
        <div>
            <h2 className="text-xl font-semibold mb-4">{t('account.subscription.title')}</h2>
            <div className="space-y-2">
                <p><strong>{t('status')}:</strong> <span className={`capitalize font-semibold ${isActive ? 'text-green-400' : 'text-yellow-400'}`}>{userData.subscription_status || 'N/A'}</span></p>
                <p><strong>{t('plan')}:</strong> <span className="capitalize">{userData.subscription_plan || 'None'}</span></p>
                {userData.subscription_end_date && <p><strong>{t('renewsOrExpires')}:</strong> {new Date(userData.subscription_end_date).toLocaleDateString()}</p>}
            </div>
            {isActive && (
                <button onClick={onCancel} className="btn-danger mt-6 hover:bg-brand-orange p-2">{t('account.subscription.cancelButton')}</button>
            )}
        </div>
    );
};

export default SubscriptionManagement;